//General
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators, FormGroup, UntypedFormBuilder, FormArray, FormGroupDirective, NgForm, UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MessageBoxComponent } from 'src/app/modals/message-box/message-box.component';
//Error
import { ErrorStateMatcher } from '@angular/material/core';
/** Error when invalid control is dirty, touched, or submitted. **/
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
//Servicio
import { TerCampService } from 'src/app/services/ter-camp.service';
//Tabla
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
//Fin Tabla
import { SesionService } from 'src/app/services/sesion.service';

@Component({
  selector: 'app-gt1-ter-camp',
  templateUrl: './gt1-ter-camp.component.html',
  styleUrls: ['./gt1-ter-camp.component.scss'],
  providers: [ TerCampService ]
})
export class Gt1TerCampComponent implements OnInit {

  /*tabla*/
  public length: number;
  public pageSize: number;
  public pageSizeOptions: Array<number>;
  public page: number;
  public displayedColumns: any;
  public dataSource: any;
  /*fin tabla*/
  public isLoading: boolean = false;
  public form: UntypedFormGroup = this.fb.group({
    buscador: new UntypedFormControl('', []),
  });
  public laravelapiStorage = this._TerCampService.getLaravelApiStorage();
  public laravelapi = this._TerCampService.getLaravelApi();
  public tieneAccionEditar = false;
  public acciones:any=[];

  constructor(
    private fb: UntypedFormBuilder,
    public  _dialog: MatDialog,
    private _TerCampService: TerCampService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _sesion:SesionService,
  ){ 
     /*tabla*/
    this.length = 100;
    this.pageSize = 25;
    this.pageSizeOptions = [5, 10, 25, 100];
    this.page = 1;
    this.displayedColumns = [
    '_no_', 
    '_fecha_',
    '_nev_',
    '_clas_',
    '_ev_',
    '_ver_ev_',
    '_el_',
    '_imp_'];
    /*fin tabla*/

    /*modificar*/
    this.getConsultarTerapias(1);
    /*fin modificar*/
    this.tieneAccionEditar = this.permiso("/medico/expedientes-medicos-generales/gt-terapias-companas/modificar");
  }

  ngOnInit(): void {
    
  }

  public permiso(urlRecibida: string){
    if(this._sesion.getSession().getUsuario().nombre!=undefined){
      this.acciones = this._sesion.getSession().getAcciones();
      if(this.acciones.filter(x => x.url == urlRecibida)[0]){
        return true;        
      }else{
        return false;
      }
    }else{
      return false;
    }
  }

  public getConsultarTerapias(page: number){
    this.isLoading = true;
    this.page = page;
    this._TerCampService.getConsultarTerapias(this.page, this.pageSize, this.form.value.buscador).subscribe(
      response => {console.log(response);
        this.isLoading = false;
        if(response.estado == 200){
          this.length = response.data.total;
          this.dataSource = response.data.data;
        }
      },
      error => {console.log(<any>error);
        this.isLoading = false;
      });
  }

  public pageEvent(event: any){
    console.info(event);
    this.pageSize = event.pageSize;
    this.getConsultarTerapias(event.pageIndex + 1);
  }

  public postEliminarTerapia(id: number){
    this.isLoading = true;
    this._TerCampService.postEliminarTerapia({numero_terapia: id}).subscribe(
      response => {console.log(response);
        this.isLoading = false;
        if(response.estado == 200){
          this._dialog.open(MessageBoxComponent,{ disableClose: true ,data: {titulo: 'Operación Exitosa', mensaje: response.mensaje, icon:'correct'}});
          this.getConsultarTerapias(this.page);
        }else{
          this._dialog.open(MessageBoxComponent,{ disableClose: true ,data: {titulo: 'Error', mensaje: response.mensaje, icon:'error'}});
        }
      },
      error => {console.log(<any>error);
        this._dialog.open(MessageBoxComponent, { disableClose: true ,data: {titulo: 'Error', mensaje: 'Error con el Servicio.', icon:'error'}});
        this.isLoading = false;
      });
  }

}
